<template>
  <div class="pwc-picker-container">
    <pwc-container class="survey-container">
      <van-image class="logo" :src="require('../../assets/logo.png')" />
      <div v-if="!submited" class="survey-label-container">
        <h6 class="survey-title">{{ data.Title }}</h6>
      </div>
      <DyForm v-if="!submited" ref="dyform" :data="data" :form-data="formData" @submitForm="(val) => {submitForm(val)}" />
      <thankPage v-else />
    </pwc-container>
    <v-dialog v-if="showVerifyDialog" v-model="showVerifyDialog" max-width="320" persistent>
      <v-card>
        <v-form ref="verifyform" class="pwc-dialog-submit">
          <pwc-phone :phone.sync="verification.phoneNo" :disabled="!!userInfo.phoneNo" :code.sync="verification.contryCode" />
          <pwc-phone-verify :resendable="validatePhone()" :verify-code="handleGetVerifyCode" :code.sync="verification.verificationCode" />
          <div style="font-size: 12px; color: #aaa">验证码会发送至你的手机和邮箱（如已留邮箱）</div>
        </v-form>
        <v-card-actions>
          <v-spacer />
          <v-btn :disabled="loading.saveNewSurveyAnswerLoading" color="#d04a02" flat="flat" @click="handleVerifyDialogCancel">取消</v-btn>
          <v-btn color="#d04a02" flat="flat" :loading="loading.saveNewSurveyAnswerLoading" @click="handleVerifyDialogConfirm">确定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import PwcContainer from '@/views/layout/mobile/PwcContainer'
import { common } from './common/mixin'
import thankPage from './common/thanks'
import { validPhone, validOtherPhone } from '@/util/validation'
import DyForm from '@/components/PwcDyForm/mobile'
import { Image } from 'vant'
export default {
  components: {
    DyForm,
    PwcContainer,
    [Image.name]: Image,
    thankPage
  },
  mixins: [common],
  data() {
    return {
    }
  },
  methods: {
    validPhone,
    validOtherPhone,
    // submitForm(val) {

    // },
    validatePhone() {
      // eslint-disable-next-line eqeqeq
      if (this.verification.contryCode == 86) {
        return this.validPhone(this.verification.phoneNo)
        // eslint-disable-next-line eqeqeq
      } else if (this.verification.contryCode != 86) {
        return this.validOtherPhone(this.verification.phoneNo)
      }
    }
  }
}
</script>

<style lang="scss">
.pwc-picker-container {
  width: 100vw;
  height: 100vh;
  overflow-y: auto;
  .survey-container {
    font-family: Microsoft YaHei, Georgia, Times New Roman, Times, serif !important;
    position: relative;
    background-color: #fff;
    padding: 20px;
    .logo {
      width: 100%;
      max-width: 600px;
      margin: 0px auto;
      padding: 20px 20px 30px 20px;
    }
    .survey-title {
      font-size: 18px;
      font-weight: 400;
      text-align: center;
      padding: 10px 0;
      margin-top: 20px;
    }
    .body {
      .item {
        margin: 10px 0;
      }
      .question-text {
        color: #455a64;
        margin-bottom: 6px;
        font-size: 18px;
        font-weight: 400;
        line-height: 24px;
      }
      .question-label {
        margin: 0;
        padding: 10px 0 10px 5px;
        color: #777;
        font-weight: 400;
        font-size: 16px;
        line-height: 20px;
      }
      .question-label_required:before {
        position: absolute;
        left: 15px;
        color: #d04a02;
        font-size: 14px;
        content: "*";
      }
    }
  }
}
</style>
